<template>
  <DashboardTemplate :navMenu="true" class="set-assignment">
    <div class="text-left pd-b-5">
      <h2 class="mg-less text-break-word">
        งานที่ได้รับมอบหมาย {{ getPrefixLabel(prefix) }}{{ nameTh }} {{lastNameTh}}
      </h2>
      <div class="flex-display column-mobile">
        <p class="text-font-14">
          <span class="text-weight-bold">หลักสูตร </span
          ><span class="color-gray text-break-word">{{ course.name }}</span>
        </p>
        <p class="text-font-14 pd-l-4"> <span class="text-weight-bold">วิชาที่</span> {{subject.index}} <span class="color-gray">{{ subject.name }}</span></p>
      </div>
    </div>
    <el-row :gutter="30" v-loading="loading">
      <el-col
        v-for="(item, index) in assignmentListSort"
        :key="item._id"
        :span="24"
        :md="12"
      >
        <AssignmentCard
          :number="index + 1"
          :title="item.name"
          :description="item.description"
          :fileList="item.attach"
          :id="item._id"
          :subjectId="subjectId"
          :courseId="courseId"
          :userId="userId"
          :showUpload="false"
          :closeDay="item.durationTime.close"
        />
      </el-col>
    </el-row>
  </DashboardTemplate>
</template>

<script>
import DashboardTemplate from "@/template/DashboardTemplate";
import AssignmentCard from "@/components/assignment/AssignmentCard";
import { HTTP } from "@/service/axios.js";

export default {
  components: {
    DashboardTemplate,
    AssignmentCard,
  },
  props: {
    routeParams: {
      type: Object,
      default: null,
    },
  },

  computed: {
    token() {
      return this.$store.state.token;
    },
    prefixList() {
      return this.$store.state.prefixList;
    },
    courseList() {
      return this.$store.state.courseList;
    },
    assignmentListSort() {
      let sort = this.assignmentList.sort((a, b) => {

        if ( Date.now() > new Date(a.durationTime.close).getTime()
        ) {
          return 1;
        }
        return -1;
      });
      return sort;
    },
  },
  data() {
    return {
      courseId: "",
      userId: "",
      subjectId: "",
      loading: true,
      prefix: "",
      nameTh: "",
      lastNameTh:'',
      assignmentList: [],
      course: "",
      subject:""
    };
  },
  mounted() {
    this.setParams();
    this.fetchCourseList();
    this.fetchStudentsById();
    this.fetchSubjectId();
  },
  methods: {
    fetchCourseList() {
      let obj = {
        token: this.token,
      };
      this.$store.dispatch("FETCH_COURSE_LIST", obj);
      let filter = this.courseList.filter(
        (filter) => filter._id == this.courseId
      );

      if (filter.length > 0) {
        this.course = filter[0];
        let course = filter[0].subject.filter(
          (filter) => filter._id == this.subjectId
        );
        if (course.length > 0) {
          this.subject = course[0];
        }
      }
    },
    setParams() {
      if (this.routeParams != null) {
        this.courseId = this.routeParams.courseId;
        this.userId = this.routeParams.userId;
        this.subjectId = this.routeParams.subjectId;
      }
    },
    fetchStudentsById() {
      let obj = {
        _id: this.userId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/student`, obj)
        .then((res) => {
          if (res.data.success) {
            this.prefix = res.data.obj.titleName;
            this.nameTh = res.data.obj.nameTH;
            this.lastNameTh = res.data.obj.surnameTH;
          }
        })
        .catch((e) => {
          console.log("fetchStudentsById error", e);
        });
    },
    fetchSubjectId() {
      let obj = {
        subjectId: this.subjectId,
      };

      HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
      HTTP.post(`get/subject`, obj)
        .then((res) => {
          if (res.data.success) {
            this.assignmentList = res.data.obj.assignment;
          } else {
            this.alertFailError();
          }
        })
        .catch((e) => {
          this.alertCatchError(e);
          console.log("fetchSubjectId error", e);
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 500);
        });
    },
    getPrefixLabel(id) {
      let filter = this.prefixList.filter((filter) => filter.id == id);
      if (filter.length > 0) {
        return filter[0].label;
      }
    },
  },
};
</script>